import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import {
  Box,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import { useGridApiRef, GRID_CHECKBOX_SELECTION_COL_DEF } from '@mui/x-data-grid';
import { DataGrid } from '../../../components/common/datagrid/ResponsiveDataGrid';
import _ from 'lodash';
import { createDraggablePaperComponent } from '../../../components/common/dialog/DraggablePaper';
import { listProductsPrice } from '../../../modules/productModule/productsPrice';
import BootstrapDialog, {
  BootstrapDialogTitle,
} from '../../../components/common/dialog/BootstrapDialog';
import * as yup from 'yup';
import { ProductListBox } from '../../../components/chancemng/costcalc/ProductListBox';

const PaperComponent = createDraggablePaperComponent('draggable-product-dialog');

const ProdcutPriceModalContainer = ({
  title,
  open,
  handleClose,
  onSelectedProducts,
  selectedPartner,
}) => {
  const dispatch = useDispatch();
  const [pageSize, setPageSize] = React.useState(100);
  const { products, error, loading } = useSelector(
    ({ productModule, loading }) => ({
      products: productModule.productsPrice.products,
      error: productModule.productsPrice.error,
      loading: loading['product/LIST_PRODUCTS_PRICE'],
    }),
  );

  const apiRef = useGridApiRef();

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'priceUuid',
        headerName: 'priceUuid',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'productUuid',
        headerName: '제품코드',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'partnerNm',
        headerName: '제조사',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      // {
      //   field: 'pricePartnerNm',
      //   headerName: '매입처',
      //   minWidth: 200,
      //   flex: 1,
      //   type: 'string',
      //   editable: false,
      // },
      {
        field: 'productNm',
        headerName: '제품명',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'productDesc',
        headerName: '사양',
        hide: true,
      },
      {
        field: 'productUnit',
        headerName: '단위',
        hide: true,
      },
      {
        field: 'category',
        headerName: '아이템',
        hide: true,
      },
      {
        field: 'modelNm',
        headerName: '모델명',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },

      {
        field: 'priceUuid',
        headerName: '가격ID',
        minWidth: 200,
        flex: 1,
        hide: true,
      },
      // {
      //   field: 'priceTyp',
      //   headerName: '가격타입',
      //   minWidth: 150,
      //   flex: 0.8,
      // },
      {
        field: 'price',
        headerName: '매입가',
        minWidth: 150,
        flex: 0.8,
        type: 'number',
        editable: false,
        valueFormatter: (params) => {
          const valueFormatted = Number(params.value).toLocaleString('ko-KR');
          return `₩ ${valueFormatted}`;
        },
      },
      {
        field: 'priceVal',
        headerName: '매출가',
        minWidth: 150,
        flex: 0.8,
        type: 'number',
        editable: false,
        valueFormatter: (params) => {
          const valueFormatted = Number(params.value).toLocaleString('ko-KR');
          return `₩ ${valueFormatted}`;
        },
      },
    ],
    [],
  );

  const onSaveCalcPrice = () => {
    //const rowIds = Array.from(apiRef.current.getSelectedRows().keys());
    const rowValues = Array.from(apiRef.current.getSelectedRows().values());
    // console.log(rowValues, 'rows');

    const data = [];
    _.map(rowValues, (row) => {
      let productPrice = {
        ...row,
        sellPartnerNm: row.partnerNm,
        sellPartnerUuid: row.partnerUuid,
        // partnerUuid: row.partnerUuid,
        // priceUuid: row.priceUuid,
        // productUuid: row.productUuid,
        expCnt: 1,
        unitVal: row.priceVal, //매출단가
        saleVal: row.priceVal, //매출금액
        priceVal: row.price, //매입단가
        buyVal: row.price, //매입금액
        salePct: 0,
        productDesc: row.productDesc,
        productUnit: row.productUnit,
        itemCd: row.category,
      };
      data.push(productPrice);
    });

    console.log(data);
    onSelectedProducts(data);
    onCloseHandler();
  };

  const [searchKeyword, setSearchKeyword] = useState('productNm');
  const [searchWords, setSearchWords] = useState('');

  const initialValues = {
    searchKeyword: searchKeyword,
    searchWords: searchWords,
  };

  const validationSchema = yup.object({
    searchKeyword: yup.string('').nullable(),
    searchWords: yup.string('').trim().nullable(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);
      setSearchKeyword(values.searchKeyword);
      setSearchWords(values.searchWords);

      setSubmitting(false);
    },
  });

  const onSearchList = () => {
    let searchData = {
      searchPartnerUuid: selectedPartner,
      [searchKeyword]: searchWords,
    };

    dispatch(listProductsPrice(searchData));
  };

  useEffect(() => {
    onSearchList();
  }, [selectedPartner, searchKeyword, searchWords]);

  const onCloseHandler = () => {
    setSearchKeyword('productNm');
    setSearchWords('');
    handleClose();
  };

  return (
    <BootstrapDialog
      open={open}
      onClose={onCloseHandler}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-product-dialog"
      fullWidth={true}
      maxWidth="lg"
    >
      <BootstrapDialogTitle
        style={{ cursor: 'move' }}
        id="draggable-product-dialog"
        onClose={onCloseHandler}
      >
        원가 산출 - 제품 선택
      </BootstrapDialogTitle>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <DialogContent>
          <Box>
            <ProductListBox formik={formik} />
          </Box>
          <div style={{ display: 'flex', height: 'calc(100vh - 300px)' }}>
            <div style={{ flexGrow: 1 }}>
              <DataGrid
                apiRef={apiRef}
                rows={products ? products : []}
                columns={columns}
                loading={loading}
                initialState={{
                  pinnedColumns: {
                    left: [GRID_CHECKBOX_SELECTION_COL_DEF.field],
                    right: ['actions'],
                  },
                }}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[5, 10, 20, 50, 100]}
                pagination
                checkboxSelection
                disableSelectionOnClick
                columnVisibilityModel={{
                  id: false,
                  priceUuid: false,
                  productUuid: false,
                }}
                        
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button fullWidth variant="contained" onClick={onSaveCalcPrice}>
            제품 추가(다중선택 가능)
          </Button>
        </DialogActions>
      </Box>
    </BootstrapDialog>
  );
};

export default ProdcutPriceModalContainer;
